import { DayPartitioning } from '../api/interfaces'
import { AudienceTargeting, LocationTargeting, LocationTargetingType } from '../api/interfaces/CampaignTargeting'

export const DEFAULT_DAY_PARTS: DayPartitioning = {
  monday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  tuesday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  wednesday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  thursday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  friday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  saturday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  sunday: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
}

export const DEFAULT_LOCATION_TARGETING: LocationTargeting = {
  targetingType: LocationTargetingType.Region,
  regions: [],
  zips: [],
  cities: [],
  dmas: []
}

export const DEFAULT_AUDIENCE_TARGETING: AudienceTargeting = {
  demographics: {
    ageRanges: ['all'],
    genders: ['all'],
    householdIncomes: ['all']
  },
  segments: []
}
